import React from 'react';
import DropdownWithPercentage from '../../input/DropdownWithPercentage';
import config from '../../config';
import './style.css';

export default class Row extends React.Component {

    static STATUS_OK = 'ok';
    static STATUS_ERROR = 'error';
    static STATUS_NOT_FILLED = 'empty';
    static STATUS_ACTIVE = 'active';

    constructor(props) {
        super(props);
        this.state = {
            focus: {}
        }
    }

    render() {
        const status = this.validate(this.props.row);
        return <tr className={`Row Row-status-${status.status}`} title={status.status === Row.STATUS_ERROR ? status.errors.join('. ') : status.status === Row.STATUS_ACTIVE ? 'Redigerer' : status.status === Row.STATUS_NOT_FILLED ? 'Ikke utfylt' : 'Ok'}>
            <td className="Row-cell Row-status">{this.renderStatus(status)}</td>
            {this.props.otherHeaders.map((cellKey, i) => <td className="Row-cell" key={i}>{this.props.row.other[cellKey]}</td>)}
            {this.props.row.researchActivities.map((activity, j) => <td className="Row-cell" key={j}><DropdownWithPercentage
                options={config.researchActivities}
                activity={activity}
                onChange={value => this.props.updateResearchActivity(this.props.rowIndex, j, value) }
                onBlur={ () => this.setFocus(`researchActivity${j}`, false) }
                onFocus={ () => this.setFocus(`researchActivity${j}`, true) }
            /></td>)}
            {this.props.row.healthCategories.map((activity, j) => <td className="Row-cell" key={j}><DropdownWithPercentage
                options={config.healthCategories}
                activity={activity}
                onChange={value => this.props.updateHealthCategory(this.props.rowIndex, j, value) }
                onBlur={ () => this.setFocus(`healthCategory${j}`, false) }
                onFocus={ () => this.setFocus(`healthCategory${j}`, true) }
            /></td>)}
        </tr>
    }

    renderStatus(status) {
        switch (status.status) {
            case Row.STATUS_ERROR:
                return <span className="fa fa-exclamation"/>;
            case Row.STATUS_OK:
                return <span className="fa fa-check"/>;
            case Row.STATUS_ACTIVE:
                return <span className="fa fa-pencil"/>;
                break;

        }
    }

    setFocus(key, value) {
        this.setState(prevState => {
            return {
                focus: {
                    ...prevState.focus,
                    [key]: value
                }
            }
        });
    }

    hasFocus() {
        return Object.keys(this.state.focus).reduce((acc, key) => acc || this.state.focus[key], false);
    }

    validate(row) {
        let status = Row.STATUS_NOT_FILLED;
        const errors = [];

        const researchActivitiesWithValue = row.researchActivities.filter(a => a.value !== 0);
        const researchActivitiesWithPercentage = row.researchActivities.filter(a => a.percentage !== 0);
        const researchPercentage = researchActivitiesWithValue.reduce((acc, a) => acc + a.percentage, 0);

        const healthCategoriesWithValue = row.healthCategories.filter(c => c.value !== 0);
        const healthCategoriesWithPercentage = row.healthCategories.filter(a => a.percentage !== 0);
        const healthCategoryPercentage = healthCategoriesWithValue.reduce((acc, c) => acc + c.percentage, 0);

        if (this.hasFocus()) {
            status = Row.STATUS_ACTIVE;
        } else if (researchActivitiesWithValue.length || researchActivitiesWithPercentage.length || healthCategoriesWithValue.length || healthCategoriesWithPercentage.length) {
            if (researchPercentage !== 100) {
                errors.push(`Summen av prosentandelene på forskningsaktivitet må være akkurat 100%, men er satt til er ${researchPercentage}%`);
            }
            if (healthCategoryPercentage !== 100) {
                errors.push(`Summen av prosentandelene på helsekategori må være akkurat 100%, men er satt til ${healthCategoryPercentage}%`);
            }
            status = errors.length ? Row.STATUS_ERROR : Row.STATUS_OK;
        }

        return {
            errors: errors,
            status: status
        }
    }

    shouldComponentUpdate(newProps, newState) {
        return newProps.rowIndex !== this.props.rowIndex || newProps.row !== this.props.row || newState !== this.state;
    }
}



// WEBPACK FOOTER //
// ./src/HrcsEditor/TableEditor/Row/index.js